// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ContentRouteImport } from './routes/_content'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as VerwaltungRouteImport } from './routes/verwaltung'
import { Route as ContentBarrierefreiheitRouteImport } from './routes/_content/barrierefreiheit'
import { Route as ContentDatenschutzRouteImport } from './routes/_content/datenschutz'
import { Route as ContentHaeufigeFragenRouteImport } from './routes/_content/haeufige-fragen'
import { Route as ContentImpressumRouteImport } from './routes/_content/impressum'
import { Route as ContentKontaktRouteImport } from './routes/_content/kontakt'
import { Route as ContentNutzungsbedingungenRouteImport } from './routes/_content/nutzungsbedingungen'
import { Route as ContentSchnellstartRouteImport } from './routes/_content/schnellstart'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicLogoutRouteImport } from './routes/_public/logout'
import { Route as PublicRegistrierungRouteImport } from './routes/_public/registrierung'
import { Route as PublicTeilnehmendeKommunenRouteImport } from './routes/_public/teilnehmende-kommunen'
import { Route as VerwaltungIndexRouteImport } from './routes/verwaltung/index'
import { Route as VerwaltungAdminLevelIdRouteImport } from './routes/verwaltung/$adminLevelId'
import { Route as VerwaltungHilfeRouteImport } from './routes/verwaltung/hilfe'
import { Route as VerwaltungProfilRouteImport } from './routes/verwaltung/profil'
import { Route as VerwaltungChar123AdminLevelIdChar125RouteImport } from './routes/verwaltung/{-$adminLevelId}'
import { Route as PublicBeschilderungRouteSignLocationIdRouteImport } from './routes/_public/beschilderung.$routeSignLocationId'
import { Route as PublicMeldungenReportIdRouteImport } from './routes/_public/meldungen.$reportId'
import { Route as PublicMeldungenAuswahlRouteImport } from './routes/_public/meldungen.auswahl'
import { Route as PublicServiceStationServiceStationIdRouteImport } from './routes/_public/service-station.$serviceStationId'
import { Route as PublicWegweiserRouteSignLocationIdRouteImport } from './routes/_public/wegweiser.$routeSignLocationId'
import { Route as VerwaltungAdminLevelIdIndexRouteImport } from './routes/verwaltung/$adminLevelId/index'
import { Route as VerwaltungAdminLevelIdBenutzerinnenRouteImport } from './routes/verwaltung/$adminLevelId/benutzerinnen'
import { Route as VerwaltungGlobalBenachrichtigungenRouteImport } from './routes/verwaltung/_global/benachrichtigungen'
import { Route as VerwaltungGlobalBenutzerinnenRouteImport } from './routes/verwaltung/_global/benutzerinnen'
import { Route as VerwaltungHilfeIndexRouteImport } from './routes/verwaltung/hilfe/index'
import { Route as VerwaltungHilfeSplatRouteImport } from './routes/verwaltung/hilfe/$'
import { Route as VerwaltungChar123AdminLevelIdChar125DashboardRouteImport } from './routes/verwaltung/{-$adminLevelId}/dashboard'
import { Route as VerwaltungChar123AdminLevelIdChar125MeldungenRouteImport } from './routes/verwaltung/{-$adminLevelId}/meldungen'
import { Route as VerwaltungAdminLevelIdBenutzerinnenUserIdRouteImport } from './routes/verwaltung/$adminLevelId/benutzerinnen.$userId'
import { Route as VerwaltungGlobalBenachrichtigungenIndexRouteImport } from './routes/verwaltung/_global/benachrichtigungen.index'
import { Route as VerwaltungGlobalBenachrichtigungenSystemNotificationIdRouteImport } from './routes/verwaltung/_global/benachrichtigungen.$systemNotificationId'
import { Route as VerwaltungGlobalBenachrichtigungenHinzufuegenRouteImport } from './routes/verwaltung/_global/benachrichtigungen.hinzufuegen'
import { Route as VerwaltungGlobalBenutzerinnenIndexRouteImport } from './routes/verwaltung/_global/benutzerinnen.index'
import { Route as VerwaltungChar123AdminLevelIdChar125MeldungenIndexRouteImport } from './routes/verwaltung/{-$adminLevelId}/meldungen.index'
import { Route as VerwaltungChar123AdminLevelIdChar125MeldungenReportIdRouteImport } from './routes/verwaltung/{-$adminLevelId}/meldungen.$reportId'
import { Route as VerwaltungChar123AdminLevelIdChar125MeldungenAuswahlRouteImport } from './routes/verwaltung/{-$adminLevelId}/meldungen.auswahl'
import { Route as VerwaltungGlobalBenutzerinnenUserIdIndexRouteImport } from './routes/verwaltung/_global/benutzerinnen.$userId.index'
import { Route as VerwaltungGlobalBenutzerinnenUserIdVerwaltungsebenenHinzufuegenRouteImport } from './routes/verwaltung/_global/benutzerinnen.$userId.verwaltungsebenen.hinzufuegen'

const ContentRoute = ContentRouteImport.update({
            id: '/_content',getParentRoute: () => rootRouteImport
          })
const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const VerwaltungRoute = VerwaltungRouteImport.update({
            id: '/verwaltung',path: '/verwaltung',getParentRoute: () => rootRouteImport
          })
const ContentBarrierefreiheitRoute = ContentBarrierefreiheitRouteImport.update({
            id: '/barrierefreiheit',path: '/barrierefreiheit',getParentRoute: () => ContentRoute
          })
const ContentDatenschutzRoute = ContentDatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => ContentRoute
          })
const ContentHaeufigeFragenRoute = ContentHaeufigeFragenRouteImport.update({
            id: '/haeufige-fragen',path: '/haeufige-fragen',getParentRoute: () => ContentRoute
          })
const ContentImpressumRoute = ContentImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => ContentRoute
          })
const ContentKontaktRoute = ContentKontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => ContentRoute
          })
const ContentNutzungsbedingungenRoute = ContentNutzungsbedingungenRouteImport.update({
            id: '/nutzungsbedingungen',path: '/nutzungsbedingungen',getParentRoute: () => ContentRoute
          })
const ContentSchnellstartRoute = ContentSchnellstartRouteImport.update({
            id: '/schnellstart',path: '/schnellstart',getParentRoute: () => ContentRoute
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicRoute
          })
const PublicLogoutRoute = PublicLogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => PublicRoute
          })
const PublicRegistrierungRoute = PublicRegistrierungRouteImport.update({
            id: '/registrierung',path: '/registrierung',getParentRoute: () => PublicRoute
          })
const PublicTeilnehmendeKommunenRoute = PublicTeilnehmendeKommunenRouteImport.update({
            id: '/teilnehmende-kommunen',path: '/teilnehmende-kommunen',getParentRoute: () => PublicRoute
          })
const VerwaltungIndexRoute = VerwaltungIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => VerwaltungRoute
          })
const VerwaltungAdminLevelIdRoute = VerwaltungAdminLevelIdRouteImport.update({
            id: '/$adminLevelId',path: '/$adminLevelId',getParentRoute: () => VerwaltungRoute
          })
const VerwaltungHilfeRoute = VerwaltungHilfeRouteImport.update({
            id: '/hilfe',path: '/hilfe',getParentRoute: () => VerwaltungRoute
          })
const VerwaltungProfilRoute = VerwaltungProfilRouteImport.update({
            id: '/profil',path: '/profil',getParentRoute: () => VerwaltungRoute
          })
const VerwaltungChar123AdminLevelIdChar125Route = VerwaltungChar123AdminLevelIdChar125RouteImport.update({
            id: '/{-$adminLevelId}',path: '/{-$adminLevelId}',getParentRoute: () => VerwaltungRoute
          })
const PublicBeschilderungRouteSignLocationIdRoute = PublicBeschilderungRouteSignLocationIdRouteImport.update({
            id: '/beschilderung/$routeSignLocationId',path: '/beschilderung/$routeSignLocationId',getParentRoute: () => PublicRoute
          })
const PublicMeldungenReportIdRoute = PublicMeldungenReportIdRouteImport.update({
            id: '/meldungen/$reportId',path: '/meldungen/$reportId',getParentRoute: () => PublicRoute
          })
const PublicMeldungenAuswahlRoute = PublicMeldungenAuswahlRouteImport.update({
            id: '/meldungen/auswahl',path: '/meldungen/auswahl',getParentRoute: () => PublicRoute
          })
const PublicServiceStationServiceStationIdRoute = PublicServiceStationServiceStationIdRouteImport.update({
            id: '/service-station/$serviceStationId',path: '/service-station/$serviceStationId',getParentRoute: () => PublicRoute
          })
const PublicWegweiserRouteSignLocationIdRoute = PublicWegweiserRouteSignLocationIdRouteImport.update({
            id: '/wegweiser/$routeSignLocationId',path: '/wegweiser/$routeSignLocationId',getParentRoute: () => PublicRoute
          })
const VerwaltungAdminLevelIdIndexRoute = VerwaltungAdminLevelIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => VerwaltungAdminLevelIdRoute
          })
const VerwaltungAdminLevelIdBenutzerinnenRoute = VerwaltungAdminLevelIdBenutzerinnenRouteImport.update({
            id: '/benutzerinnen',path: '/benutzerinnen',getParentRoute: () => VerwaltungAdminLevelIdRoute
          })
const VerwaltungGlobalBenachrichtigungenRoute = VerwaltungGlobalBenachrichtigungenRouteImport.update({
            id: '/_global/benachrichtigungen',path: '/benachrichtigungen',getParentRoute: () => VerwaltungRoute
          })
const VerwaltungGlobalBenutzerinnenRoute = VerwaltungGlobalBenutzerinnenRouteImport.update({
            id: '/_global/benutzerinnen',path: '/benutzerinnen',getParentRoute: () => VerwaltungRoute
          })
const VerwaltungHilfeIndexRoute = VerwaltungHilfeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => VerwaltungHilfeRoute
          })
const VerwaltungHilfeSplatRoute = VerwaltungHilfeSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => VerwaltungHilfeRoute
          })
const VerwaltungChar123AdminLevelIdChar125DashboardRoute = VerwaltungChar123AdminLevelIdChar125DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => VerwaltungChar123AdminLevelIdChar125Route
          })
const VerwaltungChar123AdminLevelIdChar125MeldungenRoute = VerwaltungChar123AdminLevelIdChar125MeldungenRouteImport.update({
            id: '/meldungen',path: '/meldungen',getParentRoute: () => VerwaltungChar123AdminLevelIdChar125Route
          })
const VerwaltungAdminLevelIdBenutzerinnenUserIdRoute = VerwaltungAdminLevelIdBenutzerinnenUserIdRouteImport.update({
            id: '/$userId',path: '/$userId',getParentRoute: () => VerwaltungAdminLevelIdBenutzerinnenRoute
          })
const VerwaltungGlobalBenachrichtigungenIndexRoute = VerwaltungGlobalBenachrichtigungenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => VerwaltungGlobalBenachrichtigungenRoute
          })
const VerwaltungGlobalBenachrichtigungenSystemNotificationIdRoute = VerwaltungGlobalBenachrichtigungenSystemNotificationIdRouteImport.update({
            id: '/$systemNotificationId',path: '/$systemNotificationId',getParentRoute: () => VerwaltungGlobalBenachrichtigungenRoute
          })
const VerwaltungGlobalBenachrichtigungenHinzufuegenRoute = VerwaltungGlobalBenachrichtigungenHinzufuegenRouteImport.update({
            id: '/hinzufuegen',path: '/hinzufuegen',getParentRoute: () => VerwaltungGlobalBenachrichtigungenRoute
          })
const VerwaltungGlobalBenutzerinnenIndexRoute = VerwaltungGlobalBenutzerinnenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => VerwaltungGlobalBenutzerinnenRoute
          })
const VerwaltungChar123AdminLevelIdChar125MeldungenIndexRoute = VerwaltungChar123AdminLevelIdChar125MeldungenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => VerwaltungChar123AdminLevelIdChar125MeldungenRoute
          })
const VerwaltungChar123AdminLevelIdChar125MeldungenReportIdRoute = VerwaltungChar123AdminLevelIdChar125MeldungenReportIdRouteImport.update({
            id: '/$reportId',path: '/$reportId',getParentRoute: () => VerwaltungChar123AdminLevelIdChar125MeldungenRoute
          })
const VerwaltungChar123AdminLevelIdChar125MeldungenAuswahlRoute = VerwaltungChar123AdminLevelIdChar125MeldungenAuswahlRouteImport.update({
            id: '/auswahl',path: '/auswahl',getParentRoute: () => VerwaltungChar123AdminLevelIdChar125MeldungenRoute
          })
const VerwaltungGlobalBenutzerinnenUserIdIndexRoute = VerwaltungGlobalBenutzerinnenUserIdIndexRouteImport.update({
            id: '/$userId/',path: '/$userId/',getParentRoute: () => VerwaltungGlobalBenutzerinnenRoute
          })
const VerwaltungGlobalBenutzerinnenUserIdVerwaltungsebenenHinzufuegenRoute = VerwaltungGlobalBenutzerinnenUserIdVerwaltungsebenenHinzufuegenRouteImport.update({
            id: '/$userId/verwaltungsebenen/hinzufuegen',path: '/$userId/verwaltungsebenen/hinzufuegen',getParentRoute: () => VerwaltungGlobalBenutzerinnenRoute
          })





const ContentRouteChildren = {
  ContentBarrierefreiheitRoute: ContentBarrierefreiheitRoute,ContentDatenschutzRoute: ContentDatenschutzRoute,ContentHaeufigeFragenRoute: ContentHaeufigeFragenRoute,ContentImpressumRoute: ContentImpressumRoute,ContentKontaktRoute: ContentKontaktRoute,ContentNutzungsbedingungenRoute: ContentNutzungsbedingungenRoute,ContentSchnellstartRoute: ContentSchnellstartRoute
}

const ContentRouteWithChildren = ContentRoute._addFileChildren(ContentRouteChildren)




const PublicRouteChildren = {
  PublicLogoutRoute: PublicLogoutRoute,PublicRegistrierungRoute: PublicRegistrierungRoute,PublicTeilnehmendeKommunenRoute: PublicTeilnehmendeKommunenRoute,PublicIndexRoute: PublicIndexRoute,PublicBeschilderungRouteSignLocationIdRoute: PublicBeschilderungRouteSignLocationIdRoute,PublicMeldungenReportIdRoute: PublicMeldungenReportIdRoute,PublicMeldungenAuswahlRoute: PublicMeldungenAuswahlRoute,PublicServiceStationServiceStationIdRoute: PublicServiceStationServiceStationIdRoute,PublicWegweiserRouteSignLocationIdRoute: PublicWegweiserRouteSignLocationIdRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)




const VerwaltungAdminLevelIdBenutzerinnenRouteChildren = {
  VerwaltungAdminLevelIdBenutzerinnenUserIdRoute: VerwaltungAdminLevelIdBenutzerinnenUserIdRoute
}

const VerwaltungAdminLevelIdBenutzerinnenRouteWithChildren = VerwaltungAdminLevelIdBenutzerinnenRoute._addFileChildren(VerwaltungAdminLevelIdBenutzerinnenRouteChildren)



const VerwaltungAdminLevelIdRouteChildren = {
  VerwaltungAdminLevelIdBenutzerinnenRoute: VerwaltungAdminLevelIdBenutzerinnenRouteWithChildren,VerwaltungAdminLevelIdIndexRoute: VerwaltungAdminLevelIdIndexRoute
}

const VerwaltungAdminLevelIdRouteWithChildren = VerwaltungAdminLevelIdRoute._addFileChildren(VerwaltungAdminLevelIdRouteChildren)




const VerwaltungHilfeRouteChildren = {
  VerwaltungHilfeSplatRoute: VerwaltungHilfeSplatRoute,VerwaltungHilfeIndexRoute: VerwaltungHilfeIndexRoute
}

const VerwaltungHilfeRouteWithChildren = VerwaltungHilfeRoute._addFileChildren(VerwaltungHilfeRouteChildren)




const VerwaltungChar123AdminLevelIdChar125MeldungenRouteChildren = {
  VerwaltungChar123AdminLevelIdChar125MeldungenReportIdRoute: VerwaltungChar123AdminLevelIdChar125MeldungenReportIdRoute,VerwaltungChar123AdminLevelIdChar125MeldungenAuswahlRoute: VerwaltungChar123AdminLevelIdChar125MeldungenAuswahlRoute,VerwaltungChar123AdminLevelIdChar125MeldungenIndexRoute: VerwaltungChar123AdminLevelIdChar125MeldungenIndexRoute
}

const VerwaltungChar123AdminLevelIdChar125MeldungenRouteWithChildren = VerwaltungChar123AdminLevelIdChar125MeldungenRoute._addFileChildren(VerwaltungChar123AdminLevelIdChar125MeldungenRouteChildren)



const VerwaltungChar123AdminLevelIdChar125RouteChildren = {
  VerwaltungChar123AdminLevelIdChar125DashboardRoute: VerwaltungChar123AdminLevelIdChar125DashboardRoute,VerwaltungChar123AdminLevelIdChar125MeldungenRoute: VerwaltungChar123AdminLevelIdChar125MeldungenRouteWithChildren
}

const VerwaltungChar123AdminLevelIdChar125RouteWithChildren = VerwaltungChar123AdminLevelIdChar125Route._addFileChildren(VerwaltungChar123AdminLevelIdChar125RouteChildren)




const VerwaltungGlobalBenachrichtigungenRouteChildren = {
  VerwaltungGlobalBenachrichtigungenSystemNotificationIdRoute: VerwaltungGlobalBenachrichtigungenSystemNotificationIdRoute,VerwaltungGlobalBenachrichtigungenHinzufuegenRoute: VerwaltungGlobalBenachrichtigungenHinzufuegenRoute,VerwaltungGlobalBenachrichtigungenIndexRoute: VerwaltungGlobalBenachrichtigungenIndexRoute
}

const VerwaltungGlobalBenachrichtigungenRouteWithChildren = VerwaltungGlobalBenachrichtigungenRoute._addFileChildren(VerwaltungGlobalBenachrichtigungenRouteChildren)




const VerwaltungGlobalBenutzerinnenRouteChildren = {
  VerwaltungGlobalBenutzerinnenIndexRoute: VerwaltungGlobalBenutzerinnenIndexRoute,VerwaltungGlobalBenutzerinnenUserIdIndexRoute: VerwaltungGlobalBenutzerinnenUserIdIndexRoute,VerwaltungGlobalBenutzerinnenUserIdVerwaltungsebenenHinzufuegenRoute: VerwaltungGlobalBenutzerinnenUserIdVerwaltungsebenenHinzufuegenRoute
}

const VerwaltungGlobalBenutzerinnenRouteWithChildren = VerwaltungGlobalBenutzerinnenRoute._addFileChildren(VerwaltungGlobalBenutzerinnenRouteChildren)



const VerwaltungRouteChildren = {
  VerwaltungAdminLevelIdRoute: VerwaltungAdminLevelIdRouteWithChildren,VerwaltungHilfeRoute: VerwaltungHilfeRouteWithChildren,VerwaltungProfilRoute: VerwaltungProfilRoute,VerwaltungChar123AdminLevelIdChar125Route: VerwaltungChar123AdminLevelIdChar125RouteWithChildren,VerwaltungIndexRoute: VerwaltungIndexRoute,VerwaltungGlobalBenachrichtigungenRoute: VerwaltungGlobalBenachrichtigungenRouteWithChildren,VerwaltungGlobalBenutzerinnenRoute: VerwaltungGlobalBenutzerinnenRouteWithChildren
}

const VerwaltungRouteWithChildren = VerwaltungRoute._addFileChildren(VerwaltungRouteChildren)

const rootRouteChildren = {
  ContentRoute: ContentRouteWithChildren,PublicRoute: PublicRouteWithChildren,VerwaltungRoute: VerwaltungRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)